/* eslint-disable no-bitwise */
import { extendDecorator } from '@/js/common/Domain/Service/mixins/decorators';
import TourProductsRepository from './TourProducts';

@extendDecorator({
    strategies: {
        getPriority(type) {
            switch (type) {
                case 'TourProduct': {
                    return 3;
                }
                case 'HotelOfferProduct': {
                    return 2;
                }
                case 'RailwayTourProduct': {
                    return 1;
                }
                default: {
                    return 0;
                }
            }
        },
        compare(fields, model1, model2) {
            let points1 = 0;
                let points2 = 0;
                let i;
                let value1;
                let value2;
                let sign;
                let field;
                const fieldsLength = fields.length;

            for (i = fieldsLength - 1; i >= 0; i--) {
                sign = 1;
                field = fields[i];

                if (_.isArray(field)) {
                    [value1, value2] = field;
                } else {
                    sign = field.dir ? field.dir : 1;

                    value1 = model1.get(field.field);
                    value2 = model2.get(field.field);
                }

                if (typeof value1 === 'string' || typeof value2 === 'string') {
                    const result = value1.localeCompare(value2);
                    if (result === 1) {
                        points1 += 1 << i;
                    } else if (result !== 0) {
                            points2 += 1 << i;
                        }
                } else if (value1 * sign > value2 * sign) {
                    points1 += 1 << i;
                    break;
                } else if (value1 * sign !== value2 * sign) {
                    points2 += 1 << i;
                    break;
                }
            }

            if (points1 > points2) {
                return 1;
            }

            return points1 === points2 ? 0 : -1;
        },
        priceUp(model1, model2) {
            const isModel1Piority = this.getPriority(model1.get('type'));
            const isModel2Piority = this.getPriority(model2.get('type'));

            if (isModel1Piority === isModel2Piority) {
                return this.priceUpRaw(model1, model2);
            }

            if (isModel1Piority < isModel2Piority) {
                return 1;
            }

            return -1;
        },
        priceUpRaw(model1, model2) {
            const price1 = model1.get('product')?.get('priceWithOilTax')
            || model1.get('product').get('price');

            const price2 = model2.get('product')?.get('priceWithOilTax')
                || model2.get('product').get('price');

            return this.compare([[price1, price2]], model1, model2);
        },
    },
})
export default class TourProductsSortedRepository extends TourProductsRepository {
}
